module.exports = __webpack_public_path__ + "img/mod_2.ab3b3790.png";